/** Textes « locations » — le français fait foi. */
export const locations = {
  filtres: { en_cours: 'En cours', a_venir: 'À venir', terminees: 'Terminées', toutes: 'Toutes' },
  titre: 'Mes locations',
  sousTitre: 'Toutes vos locations, du devis au retour · cliquez pour ouvrir le dossier',
  nouvelle: 'Nouvelle location',
  recherche: 'Numéro, client, marque ou plaque…',
  aucuneCorrespond: 'Aucune location ne correspond',
  aucuneIci: 'Aucune location ici',
  creer: 'Créer une location',
  essayez: 'Essayez avec le nom du client, la plaque, ou changez de filtre.',
  changezFiltre: 'Changez de filtre pour voir les locations passées ou à venir.',
  colNumero: 'N°', colClient: 'Client', colVehicule: 'Véhicule', colPeriode: 'Période', colTotal: 'Total prévu', colStatut: 'Statut',
  pied: (n: number, total: number | null) =>
    `${n} location(s) affichée(s)${total !== null ? ` sur ${total}` : ''}. Le dossier d'une location porte son contrat, sa caution, son état des lieux et son solde.`,
};
